<script>
import {getLibrayMaterialBill} from '../../../api/technology'
import {classify} from '../data'

export default {
  name: 'TechnologyList',
  props: {
    queryParam: {
      type: Object,
      required: true
    },
    isHaveImage: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    entrance() {
      let entrance = ''
      switch (this.queryParam.type) {
        case '1':
          switch (this.queryParam.firstClassify) {
            case '术式方案':
              entrance = '62'
              break
            case '技术前沿':
              entrance = '63'
              break
            case '专科发展':
              entrance = '64'
              break
            case '诊疗发展':
              entrance = '65'
              break
            default:
              break
          }
          break
        case '2':
          entrance = '61'
          break
        default:
          break
      }
      return entrance
    }
  },
  data() {
    return {
      classify,
      listState: {
        pageNum: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了'
      },
      isNoData: false,
      dataSource: [],
    }
  },
  methods: {
    async resetLoad() {
      if (this.listState.loading) return
      this.dataSource = []
      this.listState.pageNum = 1
      this.listState.finished = false
      this.isNoData = false
      await this.loadData()
    },
    listClick(item) {
      if (!item.fileId) return
      const fileId = item.fileId
      let entrance = this.entrance
      const userId = this.userInfo.id
      sessionStorage.setItem('traceObj', JSON.stringify({
        functionUrl: `${process.env.baseURL}${process.env.BASE_URL}/technologyDetail`,
        note: `fileId=${fileId}&userId=${userId}&entrance=${entrance}`
      }))
      window.sessionStorage.setItem('serviceId', fileId)
      window.sessionStorage.setItem('entrance', entrance)
      this.$router.push({
        path: '/technologyDetail',
        query: {
          fileId,
          entrance,
          channel: entrance
        }
      })
    },
    async loadData() {
      try {
        const params = Object.assign({}, {
          pageNum: this.listState.pageNum,
          pageSize: this.listState.pageSize
        }, this.queryParam)
        this.listState.loading = true
        const {code, data, msg} = await getLibrayMaterialBill(params)
        if (code === 0) {
          this.dataSource = this.dataSource.concat(data.list)
          if (this.listState.pageNum === 1 && !data.list.length) {
            this.isNoData = true
          }
          if (data.list.length < this.listState.pageSize) {
            this.listState.finished = true
          } else {
            this.listState.finished = false
          }
          this.listState.pageNum++
        } else {
          throw new Error(msg)
        }
      } catch (e) {
        this.$toast(e)
        throw e
      } finally {
        this.listState.loading = false
      }
    }
  }
}
</script>

<template>
  <div>
    <img src="@/assets/images/technology/no-data.png" alt="" v-if="isNoData" class="no-data-img"
         :class="isHaveImage? 'isHaveImage':''">
    <van-list v-model="listState.loading" :finished="listState && listState.finished" :finished-text="listState.finishText"
              :offset="100"
              v-else
              @load="loadData">
      <div class="technology-list-item" v-for="(item, index) in dataSource"
           v-track="{ functionName: `新技术列表-${item.materialName}-${item.materialNo}` }" :key="index"
           @click.stop="listClick(item)">
        <div class="technology-list-item-left">
          <img :src="item && item.materialThumbnail" alt="">
        </div>
        <div class="technology-list-item-right">
          <div class="technology-list-item-right-title">
            {{ item && item.materialName }}
          </div>
          <div class="technology-list-item-right-bot">
            <div class="technology-list-item-right-time">
              {{ item.createDate.substring(0, 10) }}
            </div>
            <div class="technology-list-item-right-read">
              <img src="@/assets/images/home/search_view@2x.png" alt="" class="read-icon">
              <span>{{ item.readingVolume || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<style scoped lang="less">
.no-data-img {
  width: 35%;
  position: absolute;
  left: 0;
  top: calc(350px / 2);
  right: 0;
  transform: translateY(-50%);
  margin: auto;

  &.isHaveImage {
    position: inherit;
    margin: 0 auto;
    display: block;
    transform: none;
  }
}

.van-list {
  width: 100%;

  .technology-list-item {
    width: 100%;
    height: 72px;
    border-radius: 5px;
    background: #FFFFFF;
    box-shadow: 0px 2px 7px 0px rgba(255, 97, 7, 0.15);
    display: flex;
    padding: 5px;
    box-sizing: border-box;

    & + .technology-list-item {
      margin-top: 15px;
    }

    .technology-list-item-left {
      img {
        width: 100px;
        height: 62px;
        border-radius: 4px;
        object-fit: cover;
        object-position: top;
      }
    }

    .technology-list-item-right {
      padding-left: 15px;
      padding-right: 5px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 0;

      .technology-list-item-right-title {
        font-family: Alibaba PuHuiTi 3.0;
        font-size: 13px;
        font-weight: bold;
        color: #3D3D3D;
        height: 41px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-height: 21px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
      }

      .technology-list-item-right-bot {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #6E7275;
        font-size: 12px;
        font-family: Alibaba PuHuiTi 3.0;
        font-weight: normal;

        .technology-list-item-right-time {

        }

        .technology-list-item-right-read {
          display: flex;
          align-items: center;

          .read-icon {
            width: 18px;
            margin-right: 3px;
          }
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/technology/modules/TechnologyList.vue